import React, { useContext } from 'react';
import { Dropdown, Flag } from 'semantic-ui-react'
import GlobalContext from '../../../contexts/GlobalContext';
import ConfigTheme from '../../../Theme';
import Utility from '../../../Utility';
import Auth from '../../../Auth';
import './DropdownLangue.css';

/**
 * Component DropdownLangue
 * Retourne un select de la langue
 * @param {string|array} props.className
 * @param {object} props.navigate
 * @param {object} props.match
 */
const DropdownLangue = (props) => {
  const [globalContext] = useContext(GlobalContext);

  /**
   * Quand on change de langue
   * @param Object event
   * @param Object data
   */
  const handleChange = (event, data) => {
    let lang = adaptionLangEn(data.value, true);
    localStorage.setItem('lang', lang);
    Auth.changeLangue(lang);
    // props.history.push(Utility.getUrlPage(globalContext, 'dashboard'));
    let codePage = "";
    // TODO Rétablir la transmition des infos router
    // props.match.params ne contient pas toujours l'id dans le cas des checkin et bookingDetails via la navigation
    // meme problème avec account
    if ((props.currentCodePage === "bookings" || props.currentCodePage === "checkin") && props.match.path.includes(":id") !== false) {
      codePage = props.currentCodePage + "/" + props.match.params.id;
      props.navigate(Utility.getUrlBaseName() + "/" + codePage);
    } else if (props.currentCodePage === "account") {
      if (props.match.path.includes("/account/") !== false) {
        const tabSplit = props.match.path.split("account/");
        codePage = props.currentCodePage + "/" + tabSplit[1];
        props.navigate(Utility.getUrlBaseName() + "/" + codePage);
      } else {
        props.navigate(Utility.getUrlPage(globalContext, 'dashboard'));
      }
      props.navigate(Utility.getUrlBaseName() + "/" + codePage);
    } else {
      codePage = props.currentCodePage === "checkin" ? "bookings" : props.currentCodePage;
      props.navigate(Utility.getUrlPage(globalContext, codePage));
    }
    window.location.reload();
  }

  /**
   * Adaption de la lanque UK en EN
   * @param string lang
   * @return string lang
   */
  const adaptionLangEn = (lang, sensUkEN) => {
    if (sensUkEN === true) {
      if (lang === 'UK') lang = 'EN';
    } else {
      if (lang === 'EN') lang = 'UK';
    }
    return lang;
  }

  /**
   * Retourne la liste des langues et la langue de la session pour le dropdown
   * @returns Object jsx
   */
  const langueSelect = () => {
    let langue = {
      iso: adaptionLangEn(localStorage.getItem('lang')),
      name: null,
    };
    let languages = [];
    for (let i = 0; i < globalContext.languages.length; i++) {
      // if (i > 1) continue;
      let { iso, originalName } = globalContext.languages[i];
      languages.push({
        key: iso,
        value: iso,
        text: [<Flag name={Utility.lowerCase(iso)} key={'flag' + iso} />, <span className="spanLabelPays" key={'flag' + iso + 'Span'}>{originalName}</span>],
      });
      if (langue.iso === iso) {
        langue = {
          iso: iso,
          name: originalName
        }
      }
    }
    return {
      langue: langue,
      languages: languages
    };
  }

  let objLangue = langueSelect();

  /**
   * Rendu du module
   * @returns Object jsx
   */
  return (
    <Dropdown
      item
      className={'button ' + (props.className) ? props.className : null}
      defaultValue={objLangue.langue.iso}
      onChange={handleChange}
      options={objLangue.languages}
      style={Object.assign({borderBottom : '2px solid transparent'}, ConfigTheme.color)}
    >
    </Dropdown>
  )
}

export default DropdownLangue;